<app-sub-navbar></app-sub-navbar>

<!-- Banner Background -->
<section [style.background-image]="'url(' + collectionData?.bannerUrl + ')'"
  class="header-filter-collection py-5 view-collection-banner text-center">
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1 class="fw-semi">{{ collectionData?.collectionName }}</h1>
      </div>
    </div>
  </div>
</section>

<!-- content -->

<section class="py-5 container">

  <div class="row row-cols-lg-4">

    <div class="col-md-4 col-sm-6 col-6 mb-2" *ngFor="let data of visibleCollectionsFiles">
      <figure class="skeleton--image position-relative">
        <div class="position-absolute mt-2 ms-2" *ngIf="data.isPremium">
          <span class="badge rounded cursor text-bg-dark">Pro</span>
        </div>

        <!-- data.jpeg || data.png  -->
        <a *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [routerLink]="'/illustration/' + data.slug">
          <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title"
            class="img-radius img-fluid" [class.skeleton--image]="!data.imageLoad" (load)="data.imageLoad = true" />

          <figcaption class="hide-caption figure-caption">
            <p>{{ data.title }}</p>
          </figcaption>
        </a>
      </figure>
    </div>

    <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="visibleCollectionsFiles.length === 0 && !loader">
      <div class="container">
        <img style="height: 200px;" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found">
        <h1 class="fw-bold fs-4 text-dark mb-2">Illustration not available</h1>
        <p class="mb-4 text-dark">
          We couldn't load the illustration at the moment.
        </p>
        <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
      </div>
    </div>
  </div>

  <!-- 🔹 Load More Row (SEPARATE ROW) -->
  <div class="row my-4" *ngIf="!loader && hasMoreIllus">
    <div class="col-12 d-flex justify-content-center">

      <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

        <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

        <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

      </button>

    </div>
  </div>
  <!-- 
  <div class="py-3 pad-top px-4 text-center">
    <a routerLink="/" class="btn btn-ib-red">
      Next Page &nbsp;<i class="fas fa-arrow-right"></i
    ></a>
  </div> -->
</section>